import React, { FC } from 'react'
import { TIntegration } from 'modules/api/integrations/types'
import IntegrationCardBody from './IntegrationCardBody'

type Props = {
  integration: TIntegration
}

const IntegrationCard: FC<Props> = ({ integration }) => {
  return (
    <IntegrationCardBody
      id={integration.id}
      available={integration.available}
      enabled={integration.enabled}
      name={integration.name}
      short={integration.short}
      logo={integration.logo}
      orderNo={integration.orderNo}
    />
  )
}

export default IntegrationCard
